export default {
    deleteDriverScheduledTasks_deleteConfirmation: '¿Estás seguro de que quieres eliminar la tarea del conductor',
    deleteDriverScheduledTasks_success_message: 'Tarea de Conductor Eliminada Exitosamente',
    deleteDriverScheduledTasks_for: 'para',
}